// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lBmFxOebWpUpyMj4{width:100%;height:100%;min-width:1372px}.ap3lbeexEYM_FKwH{min-width:1260px;background-color:var(--py-neutral-1)}.ap3lbeexEYM_FKwH ._lhMwm39VVsfwpxD{max-width:1440px;min-width:1260px;padding:0 56px;margin:0 auto;display:flex;flex-direction:column}.ap3lbeexEYM_FKwH ._lhMwm39VVsfwpxD .klVJnuvXuOQvwXsH{height:80px;width:100%;display:flex;align-items:center}.ap3lbeexEYM_FKwH ._lhMwm39VVsfwpxD .klVJnuvXuOQvwXsH .oAQRrB2NC4Nlwyex{margin-left:auto}.ap3lbeexEYM_FKwH ._lhMwm39VVsfwpxD .Sbp4wWvGLgwnFORL{width:100%;display:grid;grid-gap:16px}.ap3lbeexEYM_FKwH ._lhMwm39VVsfwpxD .Leba8Yrak88a6zdw{border-top:1px solid var(--py-neutral-2);width:100%}.ap3lbeexEYM_FKwH ._lhMwm39VVsfwpxD .z29FMFKsRVQfWsyY{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"engagementDashboard": `lBmFxOebWpUpyMj4`,
	"topArea": `ap3lbeexEYM_FKwH`,
	"innerPage": `_lhMwm39VVsfwpxD`,
	"header": `klVJnuvXuOQvwXsH`,
	"filter": `oAQRrB2NC4Nlwyex`,
	"sectionContent": `Sbp4wWvGLgwnFORL`,
	"divider": `Leba8Yrak88a6zdw`,
	"row": `z29FMFKsRVQfWsyY`
};
export default ___CSS_LOADER_EXPORT___;
